export default __webpack_public_path__ + "static/offline-collection-flow-67365150e1674ee013b583a3dad95f16.png";